export const FETCH_COUNTRYCODE_REQUEST = "FETCH_COUNTRYCODE_REQUEST";
export const FETCH_COUNTRYCODE_SUCCESS = "FETCH_COUNTRYCODE_SUCCESS";
export const FETCH_COUNTRYCODE_FAILURE = "FETCH_COUNTRYCODE_FAILURE";

export const FETCH_PHONEFORMAT_REQUEST = "FETCH_PHONEFORMAT_REQUEST";
export const FETCH_PHONEFORMAT_SUCCESS = "FETCH_PHONEFORMAT_SUCCESS";
export const FETCH_PHONEFORMAT_FAILURE = "FETCH_PHONEFORMAT_FAILURE";